import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Functionality } from '../context/Functionality';
import Article from './blog/Article';
export default function EmployeePost() {
    const { blogId } = useParams();
    const { getSingleBlogDetail } = useContext(Functionality);
    const api = useRef(getSingleBlogDetail); api.current = getSingleBlogDetail;
    const [post, setPost] = useState(null);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true; setPost(null); setError('');
        api.current(blogId).then(data => { if (active) setPost(data); })
            .catch(err => { if (active) setError(err.response?.data?.errMsg || 'Unable to load this article. Please try again.'); });
        return () => { active = false; };
    }, [blogId, attempt]);
    return <section><div className="blog-actions"><Link to="/blog-post">Back to articles</Link><Link to={`/add-blog/${blogId}`}>Edit</Link></div>
        <p className="blog-message">Private employee preview</p>
        {error ? <div><p role="alert">{error}</p><button onClick={() => setAttempt(value => value + 1)}>Retry</button></div> : post ? <Article post={post} /> : <p role="status">Loading preview…</p>}
    </section>;
}
